import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import PropTypes from 'prop-types';
import { memo, useState } from 'react';
import ButtonsSwatches from '../ButtonsSwatches';
import Product from './Product';
import css from './ProductListItem.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";

var filterColorwaysForSwatches = function filterColorwaysForSwatches(colorways) {
  return colorways.filter(function (_ref) {
    var node = _ref.node;
    return node.swatch !== null;
  }).map(function (_ref2) {
    var _ref2$node = _ref2.node,
        id = _ref2$node.id,
        color = _ref2$node.color,
        available = _ref2$node.available,
        swatch = _ref2$node.swatch;
    return {
      disabled: !available,
      id: swatch.id,
      image: swatch.image,
      label: color,
      value: id
    };
  });
};

var ProductListItem = function ProductListItem(_ref3) {
  var displayEditorial = _ref3.displayEditorial,
      displaySwatches = _ref3.displaySwatches,
      displayWishListToggle = _ref3.displayWishListToggle,
      faceout = _ref3.faceout,
      filter = _ref3.filter,
      lazyload = _ref3.lazyload,
      isMobile = _ref3.isMobile,
      onPLP = _ref3.onPLP,
      product = _ref3.product,
      token = _ref3.token;
  var colorways = product.colorways.edges;
  var giftCard = product.properties.giftCard;
  var initialColorwayId = faceout ? faceout.id : colorways[0].id;

  var _useState = useState(initialColorwayId),
      _useState2 = _slicedToArray(_useState, 2),
      colorwayId = _useState2[0],
      setColorwayId = _useState2[1];

  var _ref4 = colorways.find(function (_ref5) {
    var node = _ref5.node;
    return node.id === colorwayId;
  }) || colorways[0],
      colorway = _ref4.node;

  var swatches = displaySwatches ? filterColorwaysForSwatches(colorways) : [];
  var colorNode = !giftCard && swatches.length < 1 ? false : /*#__PURE__*/_jsx("em", {
    className: css.colorCount,
    children: "".concat(swatches.length, " color").concat(swatches.length === 1 ? '' : 's', " available")
  });

  var onSwatchClick = function onSwatchClick(value) {
    setColorwayId(value);
  };

  return /*#__PURE__*/_jsx(Product, {
    colorNode: colorNode,
    colorway: colorway,
    displayEditorial: displayEditorial,
    displayPrice: !giftCard,
    displayWishListToggle: displayWishListToggle,
    filter: filter,
    handle: product.handle,
    isMobile: isMobile,
    lazyload: lazyload,
    onPLP: onPLP,
    product: product,
    token: token,
    url: "".concat(product.absoluteUrl, "/"),
    children: displaySwatches && /*#__PURE__*/_jsx("div", {
      className: css.buttonsImages,
      children: /*#__PURE__*/_jsx(ButtonsSwatches, {
        enableClickWhenDisabled: true,
        label: "Select a color For ".concat(product.title),
        onClick: onSwatchClick,
        options: swatches,
        productTitle: product.title,
        value: colorway.id
      })
    })
  }, product.id);
};

ProductListItem.defaultProps = {
  faceout: false,
  filter: false,
  displayEditorial: false,
  lazyload: false,
  isMobile: false,
  token: false
};
ProductListItem.propTypes = {
  displaySwatches: PropTypes.bool.isRequired,
  displayWishListToggle: PropTypes.bool,
  isMobile: PropTypes.bool,
  faceout: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({
    id: PropTypes.string
  })]),
  filter: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape()]),
  displayEditorial: PropTypes.bool,
  lazyload: PropTypes.bool,
  onPLP: PropTypes.bool,
  product: PropTypes.shape({
    absoluteUrl: PropTypes.string,
    handle: PropTypes.string.isRequired,
    properties: PropTypes.shape({
      giftCard: PropTypes.bool
    }),
    colorways: PropTypes.shape({
      edges: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        assets: PropTypes.arrayOf(PropTypes.shape()),
        variantStacks: PropTypes.arrayOf(PropTypes.shape())
      }))
    }),
    title: PropTypes.string,
    id: PropTypes.string
  }).isRequired,
  token: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
};
export default /*#__PURE__*/memo(ProductListItem);